import React from 'react'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import Typography from '@material-ui/core/Typography'

import classes from './CustomTextField.module.scss'
export default function CustomTextField(props) {
  const { label = '', name, required, readOnly, constainerStyle = {}, error, onChange, type, ...other } = props
  const { value = '' } = props

  const [_error, setError] = React.useState()
  React.useEffect(() => {
    setError()
    if (typeof value === 'string') {
      if (!value.trim()) setError(error)
    }
    if (typeof value === 'number') {
      if (value <= 0) setError(error)
    }
  }, [error, value])

  const inputStyle = {
    fontSize: '14px',
  };

  const handleOnChange = e => {
    setError()
    if (typeof onChange === 'function') onChange(e)
  }

  return (
    <div className={classes.root} style={constainerStyle}>
      <Typography variant='subtitle2' className={classes.label}>
        {label}
        {!readOnly && required ? ' *' : ''}
      </Typography>
      <div className={classes.wrapper}>
        {readOnly ? (
          //  Read Only Value
          <Typography id={props.id} variant='subtitle2' className={`${classes.label} ${classes['read-only-value']}`}>
            {props.value}
          </Typography>
        ) : (
          <React.Fragment>
            <Paper className={`${classes['text-field']} ${_error && classes['has-error']}`}>
              <InputBase style={inputStyle} name={name} className={classes.input} onChange={handleOnChange} type={type} {...other} autoComplete='no' />
            </Paper>
            {_error && <span className={classes.error}>{_error}</span>}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}
